var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sc-message" }, [
    _c(
      "div",
      {
        staticClass: "sc-message--content",
        class: {
          sent: _vm.message.author === "me",
          received:
            _vm.message.author !== "me" && _vm.message.type !== "system",
          system: _vm.message.type === "system"
        }
      },
      [
        _vm._t(
          "user-avatar",
          function() {
            return [
              _vm.message.type !== "system"
                ? _c("div", {
                    staticClass: "sc-message--avatar",
                    style: {
                      backgroundImage: "url(" + _vm.chatImageUrl + ")"
                    },
                    attrs: { title: _vm.authorName }
                  })
                : _vm._e()
            ]
          },
          { message: _vm.message, user: _vm.user }
        ),
        _vm._v(" "),
        _vm.message.type === "text"
          ? _c("TextMessage", {
              attrs: {
                message: _vm.message,
                messageColors: _vm.determineMessageColors(),
                messageStyling: _vm.messageStyling
              },
              on: {
                remove: function($event) {
                  return _vm.$emit("remove")
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(scopedProps) {
                      return [
                        _vm._t("text-message-body", null, {
                          message: scopedProps.message,
                          messageText: scopedProps.messageText,
                          messageColors: scopedProps.messageColors,
                          me: scopedProps.me
                        })
                      ]
                    }
                  },
                  {
                    key: "text-message-toolbox",
                    fn: function(scopedProps) {
                      return [
                        _vm._t("text-message-toolbox", null, {
                          message: scopedProps.message,
                          me: scopedProps.me
                        })
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          : _vm.message.type === "emoji"
          ? _c("EmojiMessage", { attrs: { data: _vm.message.data } })
          : _vm.message.type === "file"
          ? _c("FileMessage", {
              attrs: {
                data: _vm.message.data,
                messageColors: _vm.determineMessageColors()
              }
            })
          : _vm.message.type === "typing"
          ? _c("TypingMessage", {
              attrs: { messageColors: _vm.determineMessageColors() }
            })
          : _vm.message.type === "system"
          ? _c(
              "SystemMessage",
              {
                attrs: {
                  data: _vm.message.data,
                  messageColors: _vm.determineMessageColors()
                }
              },
              [
                _vm._t("system-message-body", null, {
                  message: _vm.message.data
                })
              ],
              2
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-327f51f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327f51f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/Message.vue
// module id = 1917
// module chunks = 116